// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"7f3ac375","252":"04d8a5a1","346":"f71d67c2","361":"3caf5c4e","427":"3db37fe7","437":"cb4760ea","453":"9abbcebc","501":"2d52e41b","507":"feb58d21","520":"ff226de8","582":"7d9e9a39","729":"02114347","947":"30e5db96"}[chunkId] + ".chunk.js";
};